module.exports = __webpack_public_path__ + "static/img/img_7.def89a3c.png";